import {Container} from '@/components/ui/container/Container'
import {Divider} from '@/components/ui/divider/Divider'
import {useTheme} from 'styled-components'
import {StyledGrid} from './style'

interface ProPhotosGridProps {
    leftSlot: React.ReactNode
    rightSlot: React.ReactNode
}
export const ProPhotosGrid = ({leftSlot, rightSlot}: ProPhotosGridProps) => {
    const {palette} = useTheme()
    return (
        <Container fullWidth fullHeight={false}>
            <StyledGrid>
                {leftSlot}

                <Divider direction="vertical" background={palette.neutral[300]} startSpacing={6} endSpacing={6} />

                {rightSlot}
            </StyledGrid>
        </Container>
    )
}
ProPhotosGrid.displayName = 'ProPhotosGrid'
